<template>
  <el-select
    v-model="search.projectId"
    :placeholder="placeholder || '项目'"
    style="margin: 0 30px 0 16px"
    size="mini"
    collapse-tags
    clearable
    @change="changeProject"
  >
    <el-option
      v-for="item in projectList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <div class="flexRowCenter2">
        <img
          :src="item.avatarUrl || defaultImg"
          alt=""
          style="
            width: 24px;
            height: 24px;
            margin-right: 8px;
            border-radius: 50%;
          "
        />
        <div>{{ item.name }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
// import Mission from "@/tool/classFactory/Mission.js";

export default {
  props: {
    projectId: {
      type: Number,
    },
    placeholder: {
      type: String,
      default: "项目"
    },
  },
  data() {
    return {
      projectList: [],
      search: {
        projectId: []
      }
    }
  },
  created() {
    if(this.projectId) {
      this.search.projectId = this.projectId
    }
    this.getProject()
  },
  watch: {
    projectId(newVal, oldVal) {
      this.getProject()
    },
  },
  methods: {
    async getProject() {
      let res = await Mission.prototype.employee({projectId: this.projectId,page: 1,pageSize:999});
      this.projectList = res.data.data || [];
      this.projectList.forEach(item => {
        
      })
    },
    changeProject() {
      if(this.search.projectId != this.projectId) {
        this.$emit("update:projectId", this.search.projectId);
        this.$emit("changeProject",this.search.projectId)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.mission_main {
  height: calc(~'100vh - 74px');
  background: #f7f7f7;
  overflow-y: auto;
}
.search_mian {
  flex-wrap: wrap;
  min-height: 40px;
  background: #ffffff;
  padding: 3px 20px 4px 20px;
  max-height: 80px;
  width: 100%;

  .type_arr {
    .type_line {
      width: 3px;
      height: 15px;
      background: #0a89ff;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin-right: 3px;
    }
    .type_item {
      font-size: 14px;
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 400;
      color: #666666ff;
      margin-right: 40px;
    }
    .type_item_selected {
      font-size: 14px;
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: 400;
      color: #0a89ff;
      margin-right: 40px;
    }
  }
  /deep/ .el-input--prefix {
    width: 159px;
    height: 28px;
  }
  /deep/ .el-input__inner {
    width: 159px;
    height: 28px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #d9d9d9;
    // color: #999999;
    font-size: 14px;
  }

  /deep/ .el-input__prefix {
    top: -5px;
  }
}

.new-button {
  width: 84px;
  height: 28px;
  background: #1890ff;
  border-radius: 2px 2px 2px 2px;
  opacity: 1;
  font-size: 14px;
  font-family: Source Han Sans SC-Regular, Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  cursor: pointer;
  margin-left: 30px;
}
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/select/selectProject.vue